import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { BookOpen, Users, Award, Target } from 'lucide-react';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <div className="relative h-96 bg-gray-900">
        <img
          src="https://images.unsplash.com/photo-1594608661623-aa0bd3a69d98"
          alt="Students walking to school"
          className="w-full h-full object-cover opacity-70"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/40 flex items-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4">
              About AMTEE Public School
            </h1>
            <p className="text-xl text-gray-200">
              Building Nation With Education Since 2017
            </p>
          </div>
        </div>
      </div>

      {/* Mission & Vision */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            <Card className="border-l-4 border-l-[#4A90E2] shadow-lg">
              <CardHeader>
                <CardTitle className="flex items-center gap-3 text-2xl">
                  <Target className="h-8 w-8 text-[#4A90E2]" />
                  Our Mission
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 leading-relaxed">
                  To provide quality education that empowers students with knowledge, skills, and values necessary to become responsible citizens and contribute to nation-building.
                </p>
              </CardContent>
            </Card>

            <Card className="border-l-4 border-l-[#4A90E2] shadow-lg">
              <CardHeader>
                <CardTitle className="flex items-center gap-3 text-2xl">
                  <Award className="h-8 w-8 text-[#4A90E2]" />
                  Our Vision
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 leading-relaxed">
                  To be a center of excellence in education, nurturing young minds to achieve their full potential and become leaders of tomorrow.
                </p>
              </CardContent>
            </Card>
          </div>

          {/* About Content */}
          <div className="prose max-w-none">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Welcome to AMTEE Public School</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Established in 2017 and affiliated with the U.P. Board (Affiliation No. 10844-46/2017-18), AMTEE Public School is committed to providing quality education in Bahraich. Located at Malhipur Road, Near Manav Sewa Clinic, our school has been serving the community with dedication and excellence.
            </p>
            <p className="text-gray-600 leading-relaxed mb-4">
              We believe in holistic development of students, focusing not just on academic excellence but also on character building, sports, and extracurricular activities. Our experienced faculty members are dedicated to nurturing each student's unique talents and abilities.
            </p>
            <p className="text-gray-600 leading-relaxed">
              With modern facilities, including smart classrooms, library, computer lab, and sports grounds, we provide an environment conducive to learning and growth. Our motto "Building Nation With Education" reflects our commitment to developing responsible citizens who will contribute to society and the nation.
            </p>
          </div>
        </div>
      </section>

      {/* Key Features */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            Why Choose Us
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <Card className="shadow-lg hover:shadow-xl transition-shadow duration-300">
              <CardHeader>
                <div className="w-16 h-16 bg-[#4A90E2]/10 rounded-full flex items-center justify-center mb-4">
                  <BookOpen className="h-8 w-8 text-[#4A90E2]" />
                </div>
                <CardTitle>Quality Education</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600">
                  U.P. Board affiliated curriculum with focus on conceptual understanding and practical application.
                </p>
              </CardContent>
            </Card>

            <Card className="shadow-lg hover:shadow-xl transition-shadow duration-300">
              <CardHeader>
                <div className="w-16 h-16 bg-[#4A90E2]/10 rounded-full flex items-center justify-center mb-4">
                  <Users className="h-8 w-8 text-[#4A90E2]" />
                </div>
                <CardTitle>Experienced Faculty</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600">
                  Qualified and dedicated teachers committed to student success and personal growth.
                </p>
              </CardContent>
            </Card>

            <Card className="shadow-lg hover:shadow-xl transition-shadow duration-300">
              <CardHeader>
                <div className="w-16 h-16 bg-[#4A90E2]/10 rounded-full flex items-center justify-center mb-4">
                  <Award className="h-8 w-8 text-[#4A90E2]" />
                </div>
                <CardTitle>Holistic Development</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600">
                  Focus on academics, sports, arts, and character building for all-round development.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
